<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Customers from '@/services/Customers';
    import moment from "moment";
    import modalEditCompany from "@/components/modals/customers/modalEditCompany";
    import modalEditBusinessMember from "@/components/modals/business/modalEditBusinessMember";
    import modalAddMember from "@/components/modals/business/modalAddCompanyMember.vue";
    import  modalAddBusinessMember from "@/components/modals/business/modalAddBusinessMember";
    import modalAttachExternalProvider from "@/components/modals/business/modalAttachExternalProvider.vue";
    import modalMemberFromExternalSource from "@/components/modals/business/modalMemberFromExternalSource.vue";
    import modalAddCompanyAssets from "@/components/modals/business/modalAddCompanyAssets.vue";
    import Swal from "sweetalert2";
    import Business from "@/services/Business";

    export default {
        components: {
            Layout,
            PageHeader,
            modalEditCompany,
            modalEditBusinessMember,
            modalAddBusinessMember,
            modalAddMember,
            modalAttachExternalProvider,
            modalMemberFromExternalSource,
            modalAddCompanyAssets
        },
        page: {
            title: "Companies",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                isAuthorized: false,
                error: null,
                filterData: false,
                showMap: false,
                external_provider_name:'',
                title: "Company Detail",
                items: [
                    {
                        text: "Companies",
                        href: "/business/companies",
                    },
                    {
                        text: "Companies Detail",
                        active: true,
                    },
                ],
                userStatuses: [],
                companyData: {},
                members: [],
                aassets: [],
                isBusy: false,
                totalRows: 0,
                toggleProfile: false,
                businessMemberData:{
                    customer_id:"",
                    email:"",
                    name:"",
                    surname:"",
                    profile_url: "",
                    phone_number:"",
                    company_role:"",
                    linkedin_url:""
                },
                modalData: {
                    name: "",
                    website: "",
                    description: "",
                    background_color: "",
                    logo_url: null,
                    company_image: null,
                },

            };
        },
        async mounted() {
            this.getCompanies();
        },
        methods: {
            async getCompanies(){
                try {
                    this.toggleBusy();
                    const companyId = this.$route.params.id;
                    const filters = `limit=10000&company_id=${companyId}`;

                    const [companyResponse, usersResponse] = await Promise.all([
                        Customers.getCompanies(filters),
                        Business.getBusinessUsers({
                            company_id: companyId,
                            labels: true,
                            limit: 1000,
                        }).catch(() => ({ data: { users: [] } })),
                    ]);

                    const company = companyResponse.data.data[0];
                    this.companyData = company;
                    this.external_provider_name = company.external_provider;
                    this.aassets = company.assets || [];
                    this.members = this.mergeMembersWithLabels(
                        company.club_members || [],
                        usersResponse.data.users || []
                    );
                    this.filterData = true;
                } catch (error) {
                    this.error = error.response?.data?.error || "";
                    this.filterData = false;
                } finally {
                    this.toggleBusy();
                }
            },
            mergeMembersWithLabels(members, users) {
                const labelsByCustomer = {};
                users.forEach((user) => {
                    labelsByCustomer[user.customer_id] = user.labels || [];
                });
                const merged = members.map((member) => ({
                    ...member,
                    labels: labelsByCustomer[member.customer_id] || [],
                }));
                // Sort by Name (asc) for Company Detail screen
                merged.sort((a, b) => {
                    const an = (a?.name || '').toString().trim().toLowerCase();
                    const bn = (b?.name || '').toString().trim().toLowerCase();
                    if (an < bn) return -1;
                    if (an > bn) return 1;
                    const as = (a?.surname || '').toString().trim().toLowerCase();
                    const bs = (b?.surname || '').toString().trim().toLowerCase();
                    if (as < bs) return -1;
                    if (as > bs) return 1;
                    return 0;
                });
                return merged;
            },
            callModalCompanyEdit(data) {
                this.modalData = { ...data };
                this.$nextTick(() => {
                    this.$bvModal.show("company_edit");
                });
            },
            callModalAddBusinessMembers(data) {
                this.modalData = { ...data };
                this.$bvModal.show("add_company_business_members");
            },
            callModalAddMembers(data) {
              this.modalData = { ...data };
              this.$bvModal.show("add_company_members");
            },
            callModalPullBusinessMemberFromExternalSource(data) {
              this.modalData = { ...data };
              this.$bvModal.show("add_member_from_external_source");
            },
            callModalAddBusinessCompanyAsset(data) {
              this.modalData = { ...data };
              this.$bvModal.show("add_business_company_assets");
            },
            callModalAttachExternalProvider(data,external_provider_name) {
              this.businessMemberData = { ...data };
              this.external_provider_name = external_provider_name;
              this.$bvModal.show("attach_external_provider");
            },
            callModalBusinessMemberEdit(data) {
                this.businessMemberData = { ...data };
                this.$nextTick(() => {
                    this.$bvModal.show("business_member_edit");
                });
            },
            labelBadgeStyle(label) {
                const bg = label.color || "#6c757d";
                return {
                    backgroundColor: bg,
                    color: this.labelTextColor(bg),
                };
            },
            labelTextColor(hex) {
                if (!hex) {
                    return "#fff";
                }
                const color = hex.replace("#", "");
                if (color.length !== 6) {
                    return "#fff";
                }
                const r = parseInt(color.substring(0, 2), 16);
                const g = parseInt(color.substring(2, 4), 16);
                const b = parseInt(color.substring(4, 6), 16);
                const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
                return luminance > 0.6 ? "#212529" : "#fff";
            },
            toggle() {
                this.toggleProfile = !this.toggleProfile;
            },

            deleteCompany(company_id) {
                //console.log('click')
                Swal.fire({
                    title: "Are you sure?",
                    text: "This Company will be deleted !",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes, delete it!",
                }).then((result) => {
                    if (result.value) {
                        Customers.deleteCompany(company_id)
                            .then((response) => {
                                const res = response.data.success ? response.data.success : false;
                                const error = response.data.error ? response.data.error : 'Failed';
                                if(res){
                                    Swal.fire("Removed!", "Company Removed !", "success");
                                    window.location.href = "/business/companies";
                                }else{
                                    Swal.fire("Fail!", error, "warning");
                                }
                            })
                            .catch(error => {
                                this.getCompanies();
                                Swal.fire("Fail!", error, "warning");
                            });
                    }
                });
            },

            async removeMember(customer_id) {
                Swal.fire({
                    title: "Detach Business member?",
                    text: "This Member will be detach from Company!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Detach!",
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            const company_id = this.$route.params.id;
                            const response = await Customers.deleteBusinessMembers(company_id, customer_id);
                            if (response.data.success) {
                                await this.getCompanies();
                                Swal.fire("Success!", "Business User is successfully detached from Company!", "success");
                            } else {
                                const error = response.error ? response.error : 'Failed';
                                Swal.fire("Fail!", error, "warning");
                            }
                        } catch (error) {
                            this.error = error.response && error.response.data && error.response.data.error
                                ? error.response.data.error
                                : "An error occurred while removing the member.";
                            Swal.fire("Error", this.error, "error");
                        }
                    }
                });
            },

          async detachExternalProvider(customer_id,external_customer_id) {
            Swal.fire({
              title: "Detach External User?",
              text: "This User will be detach from External Provider!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Detach!",
            }).then(async (result) => {
              if (result.isConfirmed) {
                try {
                  const payload = {
                    customer_id: customer_id,
                    external_customer_id: external_customer_id,
                  }
                  const response = await Business.detachExternalProvider(payload);
                  const result = response.data.data;
                  if (result === 'success') {
                    await this.getCompanies();
                    Swal.fire("Success!", "Business User is successfully detached from Provider!", "success");
                  } else {
                    const error = response.error ? response.error : 'Failed';
                    Swal.fire("Fail!", error, "warning");
                  }
                } catch (error) {
                  this.error = error.response && error.response.data && error.response.data.error
                      ? error.response.data.error
                      : "An error occurred while removing the provider.";
                  Swal.fire("Error", this.error, "error");
                }
              }
            });
          },

          async removeBusinessCompanyAssets(asset_id, company_id) {
              Swal.fire({
                title: "Remove Company Asset?",
                text: "This Asset will be remove from Company!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Remove!",
              }).then(async (result) => {
                  if (result.isConfirmed) {
                      try {
                          const payload = {
                              asset_id: asset_id,
                              company_id: company_id,
                          }
                          const response = await Business.removeBusinessCompanyAssets(payload);
                          const result = response.data.data;
                          if (result === 'success') {
                              await this.getCompanies();
                              Swal.fire("Success!", "Asset successfully removed from Company!", "success");
                          } else {
                              const error = response.error ? response.error : 'Failed';
                              Swal.fire("Fail!", error, "warning");
                          }
                      } catch (error) {
                          this.error = error.response && error.response.data && error.response.data.error
                              ? error.response.data.error
                              : "An error occurred while removing the provider.";
                          Swal.fire("Error", this.error, "error");
                      }
                  }
              });
          },


        },


        middleware: "authentication",
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <div v-if="!toggleProfile">
            <div v-if="filterData" class="row mb-4">
                <div class="col-xl-3">
                    <div class="card h-100">
                        <div class="card-body">
                            <div class="text-center">
                                <b-dropdown
                                        class="float-end"
                                        variant="white"
                                        right
                                        menu-class="dropdown-menu-end"
                                        toggle-class="font-size-16 text-body p-0"
                                >
                                </b-dropdown>

                                <b-dropdown
                                        class="float-end"
                                        variant="white"
                                        right
                                        menu-class="dropdown-menu-end"
                                        toggle-class="font-size-16 text-body p-0"
                                >
                                    <template v-slot:button-content>
                                        <i class="uil uil-ellipsis-v"></i>
                                    </template>
                                    <a
                                            class="dropdown-item"
                                            href="javascript:void(0);"
                                            @click="callModalCompanyEdit(companyData)"
                                    >Edit</a>

                                    <a href="javascript:void(0);" class="dropdown-item" @click="deleteCompany(companyData.company_id)">
                                        Delete
                                    </a>

                                </b-dropdown>
                                <h3 class="mt-3 mb-1">
                                    {{ companyData.name }}
                                </h3>
                                <div
                                    class="company-profile-logo"
                                    :style="{ backgroundColor: companyData.background_color || '#e8edf2' }"
                                >
                                    <img
                                        v-if="companyData.logo_url"
                                        :src="`${companyData.logo_url}?ts=${Date.now()}`"
                                        :alt="companyData.name"
                                        class="company-profile-logo__img"
                                    />
                                </div>
                                <a :href="companyData.website" target="_blank" class="nav-link">
                                    <span>{{ companyData.website }}</span>
                                </a>
                                <hr class="my-2" />
                                <p class="mt-4 mb-1" style="font-weight: bold">
                                    {{ companyData.description }}
                                </p>
                                <div v-if="companyData.labels && companyData.labels.length" class="mt-3 text-start">
                                    <p class="mb-2 fw-semibold">Labels</p>
                                    <span
                                        v-for="label in companyData.labels"
                                        :key="label.id"
                                        class="badge me-1 mb-1 label-badge"
                                        :style="labelBadgeStyle(label)"
                                        v-b-tooltip.hover
                                        :title="label.description || label.name"
                                    >
                                        {{ label.name }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

              <div class="col-xl-8">
                <div class="card mb-0">
                  <b-tabs  content-class="p-4" justified class="nav-tabs-custom">

                    <b-tab active>
                        <template v-slot:title>
                            <i class="uil uil-user-circle font-size-20"></i>
                            <span class="d-none d-sm-block">Members</span>
                        </template>
                        <div class="row">
                              <div class="col-md-12">
                                <div class="mb-3">
                                  <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light me-3"
                                     @click="callModalAddBusinessMembers(companyData)">
                                    <i class="mdi mdi-plus me-2"></i>
                                    Add New Business User
                                  </a>

                                  <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light me-3"
                                     @click="callModalPullBusinessMemberFromExternalSource(companyData)">
                                    <i class="mdi mdi-import me-2"></i>
                                    Pull User From External Source
                                  </a>

                                </div>
                              </div>
                          <div style="overflow: auto">
                            <table class="table table-striped">
                              <thead>
                              <tr>
                                <th>Member Image</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Role</th>
                                <th>Phone</th>
                                <th>LinkedIn</th>
                                <th>Labels</th>
                                <th>Ticketing Number</th>
                                <th>Action</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="member in members" :key="member.customer_id">
                                <td>
                                  <img  :src="member.profile_url ? `${member.profile_url}?ts=${Date.now()}` : require('@/assets/images/image_not_found.png')" alt="" width="50" class="img-thumbnail me-2" >
                                </td>
                                <td>{{ member.name }} {{ member.surname }}</td>
                                <td>
                                  <router-link :to="{ path: `/customers/profile/${member.customer_id}`}">{{ member.email }}
                                  </router-link>
                                </td>
                                <td>{{ member.company_role }}</td>
                                <td>{{ member.phone_number }}</td>
                                <td><a v-if="member.linkedin_url" :href="member.linkedin_url">LinkedIn Profile</a></td>
                                <td>
                                  <span
                                      v-if="!member.labels || !member.labels.length"
                                      class="text-muted"
                                  >—</span>
                                  <span
                                      v-else
                                      v-for="label in member.labels"
                                      :key="label.id"
                                      class="badge me-1 mb-1 label-badge"
                                      :style="labelBadgeStyle(label)"
                                      v-b-tooltip.hover
                                      :title="label.description || label.name"
                                  >
                                    {{ label.name }}
                                  </span>
                                </td>
                                <td>{{member.external_customer_number}}</td>

                                <td class="col-2">
                                  <!--                                        <a href="javascript:void(0);" class="px-2 text-danger" title="Detach Business User" @click="removeMember(member.customer_id)">-->
                                  <!--                                            <i class="uil uil-link-broken font-size-18"></i>-->
                                  <!--                                        </a>-->
                                  <a
                                      href="javascript:void(0);"
                                      class="px-2 text-primary"
                                      title="Edit Business Member"
                                      @click="callModalBusinessMemberEdit(member)"
                                  >
                                    <i class="uil uil-pen font-size-18"></i>
                                  </a>
                                  <a
                                      v-if="member.external_customer_id == null"
                                      href="javascript:void(0);"
                                      class="px-2 text-primary"
                                      title="Attach External Provider"
                                      @click="callModalAttachExternalProvider(member,external_provider_name)">
                                    <i class="uil uil-link font-size-18"></i>
                                  </a>
                                  <a
                                      v-if="member.external_customer_id !== null"
                                      href="javascript:void(0);"
                                      class="px-2 text-danger"
                                      title="Detach External User"
                                      @click="detachExternalProvider(member.customer_id, member.external_customer_id)">
                                    <i class="uil uil-link-broken font-size-18"></i>
                                  </a>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>

                        </div>
                    </b-tab>

                    <b-tab >
                      <template v-slot:title>
                        <i class="uil uil-coins font-size-20"></i>
                        <span class="d-none d-sm-block">Assets</span>
                      </template>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="mb-3">
                            <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light me-3"
                               @click="callModalAddBusinessCompanyAsset(companyData)">
                              <i class="mdi mdi-plus me-2"></i>
                              Add New Asset
                            </a>
                          </div>
                        </div>
                        <table class="table table-striped">
                          <thead>
                          <tr>
                              <th>Asset</th>
                              <th>Description</th>
                              <th>Active</th>
                              <th>Action</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="aasset in aassets" :key="aasset.asset_id">
                            <td>{{ aasset.name }}</td>
                            <td>{{ aasset.description }}</td>
                            <td>
                              <span>
                                   <i v-if="aasset.active === 1" class="uil uil-check font-size-18 text-success"></i>
                                   <i v-else-if="aasset.value === 0" class="uil uil-times font-size-18 text-danger"></i>
                               </span>
                            </td>
                            <td class="col-2">
                              <a
                                  v-if="aasset.asset_id !== null"
                                  href="javascript:void(0);"
                                  class="px-2 text-danger"
                                  title="Remove Company Asset"
                                  @click="removeBusinessCompanyAssets(aasset.asset_id, companyData.company_id)">
                                <i class="uil uil-trash-alt font-size-18"></i>
                              </a>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </b-tab>
                  </b-tabs>

                </div>
              </div>

            </div>

            <div v-else class="card-body d-flex align-items-center justify-content-center">
                <b-spinner large></b-spinner>
            </div>

            <modalAddBusinessMember
                :modalData="modalData"
                @onRefresh="getCompanies"
            ></modalAddBusinessMember>
          <modalAttachExternalProvider
              :businessMemberData="businessMemberData"
              :externalProviderData="external_provider_name"
              @onRefresh="getCompanies"
          ></modalAttachExternalProvider>
            <modalAddMember
              :modalData="modalData"
              @onRefresh="getCompanies"
            ></modalAddMember>
            <modalMemberFromExternalSource
              :modalData="modalData"
              @onRefresh="getCompanies"
            ></modalMemberFromExternalSource>
            <modalEditCompany
                    :modalData="modalData"
                    @onRefresh="getCompanies"
            ></modalEditCompany>
            <modalEditBusinessMember
                :businessMemberData="businessMemberData"
                @onRefresh="getCompanies"
            ></modalEditBusinessMember>
          <modalAddCompanyAssets
              :modalData="modalData"
              @onRefresh="getCompanies"
          ></modalAddCompanyAssets>
        </div>
    </Layout>
</template>

<style scoped>
.label-badge {
    font-weight: 500;
    font-size: 12px;
}

.company-profile-logo {
    width: 230px;
    height: 198px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    box-sizing: border-box;
    margin: 0 auto;
}

.company-profile-logo__img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}
</style>
